import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=be1dab80&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=be1dab80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1dab80",
  null
  
)

export default component.exports